"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VendorPricingSnapshotTransportCreate = exports.VendorPricingSnapshotTransport = exports.VendorPricingRow = exports.ReasoningTypeLabels = exports.ReasoningType = exports.ReasoningTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.ReasoningTypes = [
    'MAINTAIN',
    'AVAILABILITY',
    'TRUCK',
    'DUMPSTER',
    'ETA_TOO_LONG',
    'DIRECTED_BY_OPERATIONS',
    'RENTAL_PERIOD',
    'OTHER',
];
exports.ReasoningType = typebox_1.Type.Union(exports.ReasoningTypes.map((type) => typebox_1.Type.Literal(type)));
exports.ReasoningTypeLabels = {
    MAINTAIN: 'Maintaining Relationships with Other Vendors',
    AVAILABILITY: 'No Availability',
    TRUCK: 'Truck too Large',
    DUMPSTER: 'Dumpster too Large',
    ETA_TOO_LONG: 'ETA too Long / Late',
    DIRECTED_BY_OPERATIONS: 'Directed by Operations',
    RENTAL_PERIOD: 'Length of Rental Period',
    OTHER: 'Other',
};
/**
 * This is not the "vendor pricing snapshot" that is on order
 * rather it is intended to capture the "spreads table" in SAP
 * to track the choices made bit dispatchers and the reasoning behind them.
 */
exports.VendorPricingRow = typebox_1.Type.Object({
    vendorID: typebox_1.Type.String({ format: 'uuid' }),
    vendorName: typebox_1.Type.String(),
    priceType: typebox_1.Type.String(),
    haulRate: typebox_1.Type.Number(),
    dumpRate: typebox_1.Type.Number(),
    haulSpread: typebox_1.Type.Number(),
    dumpSpread: typebox_1.Type.Number(),
    overageSpread: typebox_1.Type.Number(),
    usingWayste: typebox_1.Type.Boolean(),
    waysteLite: typebox_1.Type.Boolean(),
    activeOrderCount: typebox_1.Type.Number(),
    lastOrderDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    lastOrderID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    pricingZoneID: typebox_1.Type.String({ format: 'uuid' }),
    materialID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
});
/**
 * This is not the "vendor pricing snapshot" that is on order
 * rather it is intended to capture the "spreads table" in SAP
 * to track the choices made bit dispatchers and the reasoning behind them.
 */
exports.VendorPricingSnapshotTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    orderID: typebox_1.Type.String({ format: 'uuid' }),
    chosenVendorID: typebox_1.Type.String({ format: 'uuid' }),
    pricingData: typebox_1.Type.Array(exports.VendorPricingRow),
    reasoning: typebox_1.Type.Optional(exports.ReasoningType),
    otherReasoning: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
/**
 * This is not the "vendor pricing snapshot" that is on order
 * rather it is intended to capture the "spreads table" in SAP
 * to track the choices made bit dispatchers and the reasoning behind them.
 */
exports.VendorPricingSnapshotTransportCreate = typebox_1.Type.Omit(exports.VendorPricingSnapshotTransport, [
    'id',
    'metadata',
    'orderID',
]);
//# sourceMappingURL=vendor-pricing-snapshot-transport.js.map